import {observer} from 'mobx-react-lite'
import React, {useState} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {ArrUtil} from 'yougile-util'
import {DataObjectId} from 'yougile-model'
import {noPropagate} from '@containers/hooks'
import {ColumnColorItem} from './column-color-item'
import {
  ColorPickerStore,
  Context,
  getAllColors
} from './column-color-picker-store'

const TwBase = tw.div`
  py-8
  px-12
  space-y-[10px]
`

const TwHeader = tw.div`
  text-10
  leading-3
  text-secondary
  uppercase
`

const TwColorRow = tw.div`
  flex
  gap-10
  items-center
  justify-between
`

export const ColumnColorPicker = observer(
  ({columnId, className}: {columnId: DataObjectId; className?: string}) => {
    const [store] = useState(() => new ColorPickerStore(columnId))
    if (!store.isAllowedToEditColor()) {
      return null
    }

    const colorsRows = ArrUtil.batch(getAllColors(), 8)
    return (
      <Context.Provider value={store}>
        <TwBase onClick={noPropagate} className={className}>
          <TwHeader>{Lang.msg.colorPicker.columnColor}</TwHeader>
          {colorsRows.map((colors, ix) => (
            <TwColorRow key={ix}>
              {colors.map(([hue, color]) => (
                <ColumnColorItem key={hue} hue={hue} color={color} />
              ))}
            </TwColorRow>
          ))}
        </TwBase>
      </Context.Provider>
    )
  }
)
